import { render, staticRenderFns } from "./AndroidHealthStatistics.vue?vue&type=template&id=1560e15e&scoped=true"
import script from "./AndroidHealthStatistics.vue?vue&type=script&lang=js"
export * from "./AndroidHealthStatistics.vue?vue&type=script&lang=js"
import style0 from "./AndroidHealthStatistics.vue?vue&type=style&index=0&id=1560e15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560e15e",
  null
  
)

export default component.exports